import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import App from './App.js';
import { evaluateRevisitPolicy } from './lib/installPrompt.js';
import './index.css';

// インストールバナーの 7 日再表示ポリシーを React マウント前に評価。
// import 副作用で beforeinstallprompt の listener も同時に登録される
// （早期登録しないとイベントを取りこぼす）。
evaluateRevisitPolicy();

const root = document.getElementById('root');
if (!root) throw new Error('#root が見つかりません');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Service Worker 登録（オフライン対応）
registerSW({ immediate: true });
